import type { UserRepository } from '../repository/UserRepository';
import type { SearchUsersRequest, SearchUsersResponse } from '../entity/UserTypes';

export class SearchUsersUseCase {
  constructor(private readonly repository: UserRepository) {}

  async execute(request: SearchUsersRequest): Promise<SearchUsersResponse> {
    if (!request.params || request.params.length === 0) {
      throw new Error('검색 파라미터가 필요합니다.');
    }
    return this.repository.searchUsers(request);
  }
}

